import { Select as AntdSelect } from 'antd';
import cx from 'clsx';
import React from 'react';
import { FaChevronDown } from 'react-icons/fa6';
import { ErrorMessage, Label, Skeleton } from '../index';
import styles from './index.module.scss';
import SelectChip from './select-chip';

const Select = ({
  value = '',
  placeholder = '',
  options = [],
  onChange = () => {},
  style,
  dropdownStyle = {},
  allowClear,
  label = '',
  errorMsg = '',
  onBlur = () => {},
  disabled = false,
  className,
  onClear = () => {},
  mode = 'single',
  loading = false,
  required = false,
  labelSize,
  labelClassName = '',
  selectSize = 'large',
  containerClassName,
  open: controlledOpen,
  onDropdownVisibleChange,
  searchEnabled = true,
  status,
}) => {
  return (
    <div className={cx(containerClassName)}>
      {label && (
        <Label size={labelSize} className={labelClassName} required={required}>
          {label}
        </Label>
      )}
      {loading ? (
        <Skeleton height={40} />
      ) : (
        <>
          <AntdSelect
            className={cx(styles.select, className)}
            value={value || undefined}
            allowClear={allowClear}
            placeholder={placeholder}
            style={style}
            labelRender={(props) => {
              return <p style={{ color: 'var(--ant-color-primary)', fontWeight: 600}}>{props?.label}</p>;
            }}
            onChange={(e, items) => e && onChange(items)}
            options={options}
            onClear={onClear}
            onBlur={onBlur}
            suffixIcon={<FaChevronDown color="var(--gray-500)" />}
            disabled={disabled}
            mode={mode}
            size={selectSize}
            maxTagTextLength={10}
            maxTagCount={'responsive'}
            status={status || (errorMsg && 'error')}
            filterOption={(input, option) =>
              typeof option?.label === 'string'
                ? option?.label?.toLowerCase()?.includes(input?.trim()?.toLowerCase())
                : true
            }
            tagRender={SelectChip}
            dropdownStyle={dropdownStyle}
            open={controlledOpen}
            onDropdownVisibleChange={onDropdownVisibleChange}
            showSearch={searchEnabled}
          />
          {errorMsg && <ErrorMessage errorMsg={errorMsg} />}
        </>
      )}
    </div>
  );
};

export default Select;
